<template>
  <LegacyModal
    class="license-modal-container"
    :show-close-button="true"
    @click-close="onClickClose"
  >
    <div class="question-modal-container">
      <div class="question-modal-body">
        <div class="title-block">
          <h4 class="question-modal-title pdp-section-title font-weight-bold h2">
            {{ title }}
          </h4>
        </div>
        <div class="content-block">
          <h5 class="submission-type mb-2">
            Your {{ type }}
          </h5>
          <!-- eslint-disable vue-a11y/form-has-label -->
          <textarea
            v-model="submission"
            class="form-control"
            rows="7"
            maxlength="3000"
          />
          <!-- eslint-enable vue-a11y/form-has-label -->
          <LegacyCheckbox
            :label="notifyLabel"
            class="my-4"
            @on-click="toggleNotify"
          />
          <div class="question-guidelines">
            <h4 class="guidelines-title">
              Please check these guidelines before submitting {{ guidelinesTitle }}:
            </h4>
            <p
              v-for="(str, index) in guidelinesBody"
              :key="index"
              class="guidelines-body"
              :class="{ 'mb-0': index === guidelinesBody.length - 1 }"
            >
              {{ str }}
              <a
                v-if="index === 2"
                class="guidelines-link"
                href="mailto:support@appsumo.com"
              >
                support@appsumo.com
              </a>
            </p>
          </div>
          <p class="community-guidelines-text px-2">
            By submitting, I agree to
            <a
              href="/community-guidelines/"
              target="_blank"
            >
              AppSumo's community guidelines</a>.
          </p>
        </div>
      </div>
      <div class="question-modal-footer">
        <button
          class="submit-btn"
          :disabled="!canSubmit"
          @click="postSubmission"
        >
          Submit
        </button>
        <button
          class="cancel-btn mr-3"
          :disabled="isProcessing"
          @click="onClickClose"
        >
          Cancel
        </button>
      </div>
    </div>
  </LegacyModal>
</template>

<script>
// TODO:BRO-1276: import DModal from '@appsumo/dorado-nuxt';
import LegacyModal from '../../utilities/LegacyModal.vue';
import LegacyCheckbox from '../../ui/LegacyCheckbox.vue';
import * as discussionService from '../../../services/discussionService';

export default {
  components: {
    LegacyModal,
    LegacyCheckbox,
  },
  props: {
    // either 'question' or 'response'
    type: {
      type: String,
      required: true,
    },
    deal: {
      type: Object,
      required: true,
    },
    // only needed if launched as a response
    commentData: {
      type: Object,
      required: false,
      default: null,
    },
    // temp prior to nuxt
    user: {
      type: Object,
      required: true,
    },
  },
  emits: ['click-close', 'update-questions'],
  data() {
    return {
      guidelinesBody: [
        `Check the FAQ and pinned comments before you post,
        your question may have already been answered!`,
        'Please don’t use this forum as a platform for requesting deal features or new terms',
        'If you have an AppSumo support related issue, shoot us an email at',
        `Be respectful of you fellow Sumo-lings and partners –
        rudeness or harassment will not be tolerated`,
      ],
      submission: '',
      isProcessing: false,
      notify: false,
      notifyLabel: 'Notify me via email when someone replies to this question',
    };
  },
  computed: {
    title() {
      return (this.type === 'question') ? 'Ask a question' : 'Add a reply';
    },
    guidelinesTitle() {
      return (this.type === 'question') ? 'a question' : 'your review';
    },
    canSubmit() {
      return !!this.submission?.length && !this.isProcessing;
    },
  },
  created() {
    discussionService.configInstance(this.$cookies);
  },
  methods: {
    onClickClose() {
      this.$emit('click-close');
    },
    toggleNotify() {
      this.notify = !this.notify;
    },
    encodeProp(key, val) {
      return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    },
    postSubmission() {
      if (this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      let data = [];
      data.push(
        this.encodeProp('object_pk', this.deal.discussion.object_pk_question),
        this.encodeProp('reply_to', (this.commentData) ? this.commentData.id : 0),
        this.encodeProp('content_type', 'deals.dealcomment'),
        this.encodeProp('timestamp', this.deal.discussion.timestamp),
        this.encodeProp('security_hash', this.deal.discussion.hash_question),
        this.encodeProp('comment', this.submission),
        this.encodeProp('followup', this.notify),
        this.encodeProp('honeypot', ''),
        this.encodeProp('email', this.user.email),
        this.encodeProp('name', this.user.username),
        this.encodeProp('title', ''),
        this.encodeProp('rating', 0),
      );
      data = data.join('&');
      const callback = (successBool) => {
        this.isProcessing = false;
        if (successBool) {
          this.$toastr.s('Your comment has been made');
          this.$emit('update-questions');
        } else {
          this.$toastr.e('Something went wrong, please try again');
        }
        this.onClickClose();
      };
      discussionService.postToDiscussions(data, callback);
    },
  },
};
</script>

<style lang="scss">
  @import '../../../styles/global';

  .checkbox-label {
    font-size: 16px !important;
    line-height: 24px !important;
  }

  .modal-container {
    max-height: 90vh !important;
    width: 520px;
  }

  .modal-close-button {
    width: 14px !important;
    height: 14px !important;
    top: 30px !important;
    right: 30px !important;
    border: 0;
    padding: 0 !important;
    background-color: transparent;
    color: #0275d8;
  }

  .modal-body {
    box-shadow: none;
  }

  .modal-close-button::before,
  .modal-close-button::after {
    background-color: #0275d8 !important;
    height: 14px;
  }

  @media screen and (max-width: $license-modal-mobile) {
    .modal-close-button {
      top: 20px !important;
      right: 20px !important;
    }
  }
</style>

<style lang="scss" scoped>
  @import '../../../styles/global';

  .cancel-btn {
    color: #0044c0;
    background: transparent;
  }

  .question-modal-title {
    margin-bottom: 24px;
  }

  .submission-type {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }

  .question-guidelines {
    background: #f5f5f9;
    border-radius: 4px;
    padding: 16px;
  }

  .community-guidelines-text {
    color: #434d59;
    font-family: Roboto, sans-serif;
    font-size: 14px !important;
    line-height: 21px;
    margin-bottom: 36px;
    margin-top: 8px;
  }

  .guidelines-title {
    font-family: Barlow, sans-serif;
    line-height: 30px;
  }

  .submit-btn {
    background: #0044c0;
    color: #fff;
  }

  .guidelines-body,
  .guidelines-link,
  .guidelines-bolded {
    font-family: Roboto, sans-serif;
    font-size: 16px;
    line-height: 24px;
  }

  .question-modal-container {
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .submit-btn,
  .cancel-btn {
    border-radius: 40px;
    padding: 8px 24px;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    border: 2px solid #0044c0;
    float: right;
  }

  .submit-btn:hover,
  .cancel-btn:hover {
    cursor: pointer;
    border-color: #699cff;
    background: #699cff;
    color: #1b1b1b;
  }

  .submit-btn:active,
  .submit-btn:focus,
  .cancel-btn:active,
  .cancel-btn:focus {
    background: #0e6ef4;
    color: #fff;
    border-color: #0e6ef4;
  }

  .submit-btn:disabled {
    opacity: 0.5;
    border: 2px solid #0044c0 !important;
    background: #0044c0 !important;
    color: #fff !important;
  }

  @media screen and (min-width: 800px) {
    .question-modal-container {
      width: 100%;
    }
  }

  @media screen and (max-width: $license-modal-mobile) {
    .question-modal-container {
      padding: 20px;
    }
  }
</style>
